import { z } from 'zod';

// Device Schema
export const deviceSchema = z.object({
  eui: z
    .string()
    .min(1, 'EUI الزامی است')
    .regex(/^[0-9A-Fa-f]{16}$/, 'EUI باید 16 کاراکتر هگزادسیمال باشد'),
  name: z
    .string()
    .min(3, 'نام باید حداقل 3 کاراکتر باشد')
    .max(100, 'نام نمی‌تواند بیشتر از 100 کاراکتر باشد'),
  address: z
    .string()
    .min(3, 'شناسه آدرس باید حداقل 3 کاراکتر باشد')
    .max(100, 'شناسه آدرس نمی‌تواند بیشتر از 100 کاراکتر باشد'),
  template_id: z.number().positive('انتخاب قالب پروفایل الزامی است'),
  application_id: z.number().positive('انتخاب اپلیکیشن الزامی است'),
});

// Device Update Schema (without EUI, template_id, application_id, address)
export const deviceUpdateSchema = z.object({
  name: z
    .string()
    .min(3, 'نام باید حداقل 3 کاراکتر باشد')
    .max(100, 'نام نمی‌تواند بیشتر از 100 کاراکتر باشد'),
});
